import React from "react";
import {
  TextLink,
  textLinkTypography,
  typography
} from "@streeteasy/design-system";
import { bool, string } from "prop-types";

import * as S from "./styled";

const { P } = typography;

const AgentDescription = ({
  agentImageSrc,
  agentName,
  agentTitle,
  brokerage,
  className,
  isPro,
  profileUrl
}) => (
  <div className={className}>
    <S.AgentDescriptionHeader>
      <S.AgentImage isPro={isPro} src={agentImageSrc} />
      <S.AgentInfoContainer data-qa="agent-details">
        <TextLink
          data-qa="agent-name"
          href={profileUrl}
          rel="noopener noreferrer"
          target="_blank"
          typography={textLinkTypography.SECONDARY_SM}
          underlined={false}
        >
          {agentName}
        </TextLink>
        <P>{agentTitle}</P>
        <P data-qa="brokerage">{brokerage}</P>
      </S.AgentInfoContainer>
    </S.AgentDescriptionHeader>
    <P>
      {agentName} is a partner agent with the StreetEasy Experts advertising
      program and has experience with similar homes in the area.
    </P>
  </div>
);

AgentDescription.propTypes = {
  agentImageSrc: string,
  agentName: string.isRequired,
  agentTitle: string.isRequired,
  brokerage: string.isRequired,
  className: string,
  isPro: bool,
  profileUrl: string.isRequired
};

AgentDescription.defaultProps = {
  agentImageSrc: null,
  className: null,
  isPro: false
};

export default AgentDescription;
